import React from 'react';
import { Link as RouterLink } from "react-router-dom";
import { Card as EcoCard } from "@bsw/react-nightingale";
//import { CardButton } from './CardButton';
//import './card.scss';

export const Card = (props) => {
    const cardAs = props?.as || (props?.href ? 'a' : props?.to ? RouterLink : undefined);
    const cardType = props?.type || (props?.as === 'button' ? 'button' : undefined);

    return <EcoCard
        {...props}
        as={cardAs}
        type={cardType}
    />;
}

//export const Card = ({
//    ariaLabel,
//    borderStyle = 'flat',
//    children,
//    className,
//    disabled,
//    href,
//    selected = false,
//    target,
//    to,
//    onClick,
//    button = false
//}) => {

//    const primaryCardClasses = [
//        `bsw-card`,
//        `bsw-card--primary`,
//        `bsw-card-border--${borderStyle}`,
//        `${selected ? 'bsw-card--selected' : ''}`,
//        `${disabled ? 'bsw-card--disabled' : ''}`,
//        `${className ? className : ''}`
//    ].join(' ');


//    return (
//        <>{(href || to || (button === true))
//            ? <CardButton
//                ariaLabel={ariaLabel}
//                borderStyle={borderStyle}
//                className={className}
//                disabled={disabled}
//                href={href}
//                to={to}
//                target={target}
//                onClick={onClick}>
//                {children}
//            </CardButton>
//            : <div
//                className={primaryCardClasses}
//                onClick={onClick}>
//                {children}
//            </div>
//        }</>
//    )
//}